//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [],
    data: function data() {
        return {
            url: route('sanctum_api.companies.index'),
            companyData: this.company > 0 ? { companies: [this.company] } : null,
            columns: [{
                name: 'name',
                label: trans('columns.name'),
                sortable: true
            }, {
                name: 'address',
                label: trans('columns.adress'),
                sortable: true,
                data: function data(item) {
                    return item.street + ', ' + item.zip + ' ' + item.location;
                }
            }, {
                name: 'credit',
                label: trans('columns.credit'),
                sortable: true
            }, {
                name: 'created_at',
                label: trans('columns.created_date'),
                sortable: true,
                data: function data(item) {
                    var date = new Date(item.created_at);
                    return date.toLocaleDateString('de', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    });
                }
            }, {
                name: 'privacy_policy',
                label: trans('columns.privacy_policy'),
                sortable: true,
                html: true,
                data: function data(item) {
                    return item.privacy_policy ? '<span class="badge badge-success"><i class="fa fa-check"></i>&nbsp;' + trans('system.yes') + '</span>' : '<span class="badge badge-danger"><i class="fa fa-times"></i>&nbsp;' + trans('system.no') + '</span>';
                }
            }]
        };
    },

    methods: {
        canEdit: function canEdit() {
            return window.Laravel.permissions.includes('companies.edit');
        },
        canEditInfos: function canEditInfos(company) {
            return window.Laravel.permissions.includes('companies.edit') && company.can_use_info_campus;
        },
        canDelete: function canDelete() {
            return window.Laravel.permissions.includes('companies.delete');
        },
        deleteCompany: function deleteCompany(company) {
            var url = route('companies.destroy', company);

            window.swal({
                title: trans('messages.confirm_header'),
                text: trans('messages.confirm_delete'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: trans('messages.proceed'),
                cancelButtonText: trans('messages.cancel')
            }).then(function (result) {
                if (result.value) {
                    axios.delete(url).then(function (response) {
                        window.swal({
                            title: trans('messages.success'),
                            html: trans('messages.delete_success'),
                            type: 'success',
                            timer: 1000,
                            showConfirmButton: false
                        }).then(function () {
                            window.location.reload();
                        });
                    }).catch(function (error) {
                        if (error.response) {
                            swal({
                                title: trans('messages.error'),
                                text: error.response.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Companies.vue
// module id = 48
// module chunks = 0